<template>
<div class="landing">
    <div class="landing-container">
        <div class="iconcontainer">
            <div class="landing-icon">
                <img src="md-logo.png"/>
            </div>
            <div class="landing-icon link" @click="navigateTo(serviceUrls[0])" v-tooltip="{toggled: true, header: this.$t('pages.landing.switchToMz'), offsety: 30}">
                <img src="mz-logo.png"/>
            </div>
            <div class="landing-icon link" @click="navigateTo(serviceUrls[1])" v-tooltip="{toggled: true, header: this.$t('pages.landing.switchToMp'), offsety: 30}">
                <img src="mp-logo.png"/>
            </div>
            <div class="landing-icon link" @click="navigateTo(serviceUrls[2])" v-tooltip="{toggled: true, header: this.$t('pages.landing.switchToMl'), offsety: 30}">
                <img src="ml-logo.png"/>
            </div>
        </div>
        <div class="labelcontainer">
            <div class="labelmy">MEIN</div>
            <div class="labeldpl">DIENSTPLAN</div>
        </div>
        <div class="button-container">
        <div class="landing-button-container" v-for="(route, index) in routes" :key="index">
            <buttonc v-bind="route" @click="UpdateMenu(route)" />
            <!--<listlabel :state="{labels: route.links.filter(l => isSuperUser || !l.superUser).map(l => LabelFromLink(l))}"/>-->
        </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapState,
    mapGetters
} from 'vuex';
export default {
    name: "LandingPage",
    data() {
        return {
            routes: [{
                    type: 'landing-button',
                    label: this.$t('global.menubar.roster'),
                    icon: 'fa-calendar-check',
                    links: [{
                            label: this.$t('shift.main.plan'),
                            name: 'planning',
                            params: {
                                storeId: this.$store.state.storeId,
                                tab: 'templateview'
                            }
                        },
                        {
                            label: this.$t('global.menubar.roster'),
                            name: 'planning',
                            params: {
                                storeId: this.$store.state.storeId,
                                tab: 'roster'
                            },
                            default: true
                        },
                        
                    ]
                },
                {
                    type: 'landing-button',
                    label: this.$t('global.menubar.planning'),
                    icon: 'fa-chart-line',
                    links: [{
                            label: this.$t('indicator.main.planning'),
                            name: 'planningindicatormain',
                            params: {
                                storeId: this.$store.state.storeId,
                                tab: 'planningindicatoroverview'
                            },
                            default: true
                        },
                        {
                            label: this.$t('indicator.main.productivity'),
                            name: 'planningindicatormain',
                            params: {
                                storeId: this.$store.state.storeId,
                                tab: 'crewlaborplanning'
                            }
                        },
                    ]
                },
                {
                    type: 'landing-button',
                    label: this.$tc('global.general.absence', 2),
                    icon: 'fa-umbrella-beach',
                    links: [{
                            label: this.$t('shift.template.view'),
                            name: 'preferences',
                            params: {
                                storeId: this.$store.state.storeId,
                                tab: 'preferenceview'
                            },
                            default: true
                        },
                        {
                            label: this.$t('pref.main.vacOverview'),
                            name: 'preferences',
                            params: {
                                storeId: this.$store.state.storeId,
                                tab: 'vacationoverview'
                            }
                        },
                        {
                            label: this.$t('pref.main.overview'),
                            name: 'preferences',
                            params: {
                                storeId: this.$store.state.storeId,
                                tab: 'employeepreferenceoverview'
                            },
                            superUser: true
                        },
                    ]
                },
                {
                    type: 'landing-button',
                    label: this.$t('global.menubar.workbalance'),
                    icon: 'fa-clipboard',
                    links: [{
                            label: this.$t('global.menubar.workbalance'),
                            name: 'workbalances',
                            params: {
                                storeId: this.$store.state.storeId,
                                tab: 'employeepayrollaccounting'
                            },
                            default: true
                        },
                        {
                            label: 'Quartalsübersicht',
                            name: 'workbalances',
                            params: {
                                storeId: this.$store.state.storeId,
                                tab: 'employeeworkbalanceoverview'
                            }
                        },
                    ]
                },
                {
                    type: 'landing-button',
                    label: this.$tc('global.general.employee', 2),
                    icon: 'fa-users',
                    links: [{
                            label: this.$t('pages.employeeContext.coreData'),
                            name: 'employees',
                            params: {
                                storeId: this.$store.state.storeId,
                                tab: 'employeedata'
                            },
                            default: true
                        },
                        {
                            label: this.$tc('pages.employeeContext.planning', 2),
                            name: 'employees',
                            params: {
                                storeId: this.$store.state.storeId,
                                tab: 'employeetypeoverviewtable'
                            }
                        },
                        {
                            label: 'Freizeit Optionen',
                            name: 'employees',
                            params: {
                                storeId: this.$store.state.storeId,
                                tab: 'employeerulesoverviewtable'
                            }
                        },
                    ]
                },
                {
                    type: 'landing-button',
                    label: this.$t('global.menubar.reports'),
                    icon: 'fa-file-signature',
                    links: [{
                            label: this.$t('report.main.workTimeOverview'),
                            name: 'reports',
                            params: {
                                storeId: this.$store.state.storeId,
                                tab: 'reportworktimeoverview'
                            },
                            default: true
                        },
                        {
                            label: this.$t('report.main.exitNotice'),
                            name: 'reports',
                            params: {
                                storeId: this.$store.state.storeId,
                                tab: 'reportnoticeofresignation'
                            }
                        },
                        {
                            label: this.$t('report.main.staffCompensation'),
                            name: 'reports',
                            params: {
                                storeId: this.$store.state.storeId,
                                tab: 'reportstaffexpenses'
                            }
                        },
                    ]
                },
                {
                    type: 'landing-button',
                    label: this.$t('global.menubar.settings'),
                    icon: 'fa-cog',
                    links: [{
                            label: this.$t('store.structure.title'),
                            name: 'storemain',
                            params: {
                                storeId: this.$store.state.storeId,
                                tab: 'storestructure'
                            },
                            default: true
                        },
                        {
                            label: this.$t('store.templates.title'),
                            name: 'storemain',
                            params: {
                                storeId: this.$store.state.storeId,
                                tab: 'storeplanningguidelines'
                            }
                        },
                        {
                            label: this.$t('store.roles.title'),
                            name: 'storemain',
                            params: {
                                storeId: this.$store.state.storeId,
                                tab: 'userroles'
                            }
                        },
                        {
                            label: this.$t('store.events.title'),
                            name: 'storemain',
                            params: {
                                storeId: this.$store.state.storeId,
                                tab: 'storeeventoverview'
                            }
                        },
                        {
                            label: this.$t('store.settings.title'),
                            name: 'storemain',
                            params: {
                                storeId: this.$store.state.storeId,
                                tab: 'storesettings'
                            }
                        },
                        {
                            label: this.$store.state.storeSettings.country == 1 ? this.$t('store.collectiveContracts.title') : this.$t('store.modelContracts'),
                            name: 'storemain',
                            params: {
                                storeId: this.$store.state.storeId,
                                tab: 'allowedcontracts'
                            }
                        },
                    ]
                },

            ],
        }
    },
    computed: {
        ...mapGetters(['isSuperUser']),
        serviceUrls() {
            let sub = this.getSubDomain();
            let urls = []
            if(sub === "staging") {
                urls =  ["https://account.meindienstplan.at/#/?redirect=stagingmzlogin", 'https://account.meindienstplan.at/#/?redirect=stagingmplogin', 'https://account.meindienstplan.at/#/?redirect="devml": ', 'https://account.meindienstplan.at/#/?redirect=stagingmdcorelogin'];
            } else if(sub === "development") {
                urls =  ["https://account.meindienstplan.at/#/?redirect=stagingmzlogin", 'https://account.meindienstplan.at/#/?redirect=stagingmplogin', 'https://account.meindienstplan.at/#/?redirect="devml": ', 'https://account.meindienstplan.at/#/?redirect=stagingmdcorelogin'];
            } else {
                urls =  ["https://account.meindienstplan.at/#/?redirect=mzlogin", 'https://account.meindienstplan.at/#/?redirect=mplogin', 'https://account.meindienstplan.at/#/?redirect=ml', 'https://account.meindienstplan.at/#/?redirect=mdcorelogin'];
            }

            return urls;

            

        },
    },
    methods: {
        LabelFromLink(link) {
            let view = this;
            return {
                text: link.label,
                type: 'block',
                click: () => {
                    view.$router.push(link);
                    if (window.menubar) window.menubar.$forceUpdate();
                }
            };
        },
        UpdateMenu(route) {
            this.$router.push(route.links.find(l => l.default));
            if (window.menubar) window.menubar.$forceUpdate();
        },
        getSubDomain: function(){
            let full = window.location.host
            //window.location.host is subdomain.domain.com
            let parts = full.split('.')
            return parts[0]
        },
        navigateTo: function(url) {
            window.location = url;
        }
    }
}
</script>

<style scoped>

.landing {
    background: #323a45;
    background-image: url(/img/md_bg_overlay.svg);
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center;
    background-size: 100% 110%;
    text-align: center;
    position: relative;
}

.landing-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 800px;
    height: fit-content;
}

.button-container {
    width: 500px;
    margin: 0px 150px 0px 150px;
}

.iconcontainer{
    height: 68px;
}

.landing-icon{
    width: 68px !important;
    height: 68px!important;
    margin: 8px;
    display: inline;
}

.landing-icon img {
    width: 60px;
    height: 60px;
}

.labelcontainer {
    margin: 16px 0px 20px 0px;
}

.labelmy {
    display: inline;
    font-size: 70px;
    color: white;
    font-family: DistrictProThin;
}

.labeldpl {
    display: inline;
    font-size: 70px;
    color: white;
    font-family: DistrictProBold;
}

.landing-button-container {
    position: relative;
    display: inline-block;
    margin: 4px 8px;
}

.landing-button-container .list-label {
    position: absolute;
    z-index: 10;
    display: none;
    width: 100%;
    background: var(--bg);
    right: -100%;
    top: 0;
    box-shadow: 0 0 1px var(--contrast-3);
}

.landing-button-container:hover .list-label {
    display: block;
}

.link :hover {
    cursor: pointer;
}
</style>
